export const quarterData = [
    { value: 1, label: 1 },
    { value: 2, label: 2 },
    { value: 3, label: 3 },
    { value: 4, label: 4 },
];

export const monthData = [
    { value: 1, label: "มกราคม" },
    { value: 2, label: "กุมภาพันธ์" },
    { value: 3, label: "มีนาคม" },
    { value: 4, label: "เมษายน" },
    { value: 5, label: "พฤษภาคม" },
    { value: 6, label: "มิถุนายน" },
    { value: 7, label: "กรกฎาคม" },
    { value: 8, label: "สิงหาคม" },
    { value: 9, label: "กันยายน" },
    { value: 10, label: "ตุลาคม" },
    { value: 11, label: "พฤศจิกายน" },
    { value: 12, label: "ธันวาคม" }
];

export const monthDataLLG = [
    { value: 1, label: "ธันวาคม" },
    { value: 2, label: "มกราคม" },
    { value: 3, label: "กุมภาพันธ์" },
    { value: 4, label: "มีนาคม" },
    { value: 5, label: "เมษายน" },
    { value: 6, label: "พฤษภาคม" },
    { value: 7, label: "มิถุนายน" },
    { value: 8, label: "กรกฎาคม" },
    { value: 9, label: "สิงหาคม" },
    { value: 10, label: "กันยายน" },
    { value: 11, label: "ตุลาคม" },
    { value: 12, label: "พฤศจิกายน" }
];

export const monthDataSSP = [
    { value: 1, label: "ตุลาคม" },
    { value: 2, label: "พฤศจิกายน" },
    { value: 3, label: "ธันวาคม" },
    { value: 4, label: "มกราคม" },
    { value: 5, label: "กุมภาพันธ์" },
    { value: 6, label: "มีนาคม" },
    { value: 7, label: "เมษายน" },
    { value: 8, label: "พฤษภาคม" },
    { value: 9, label: "มิถุนายน" },
    { value: 10, label: "กรกฎาคม" },
    { value: 11, label: "สิงหาคม" },
    { value: 12, label: "กันยายน" }
];

export const monthShortData = [
    { value: 1, label: 'ม.ค.' },
    { value: 2, label: 'ก.พ.' },
    { value: 3, label: 'มี.ค.' },
    { value: 4, label: 'เม.ย.' },
    { value: 5, label: 'พ.ค.' },
    { value: 6, label: 'มิ.ย.' },
    { value: 7, label: 'ก.ค.' },
    { value: 8, label: 'ส.ค.' },
    { value: 9, label: 'ก.ย.' },
    { value: 10, label: 'ต.ค.' },
    { value: 11, label: 'พ.ย.' },
    { value: 12, label: 'ธ.ค.' }
];

export const getTranslatedMonthShortData = (translator, translate) => {
    return [
        { value: 1, label: translator(translate.ISA_Short_January, 'ม.ค.') },
        { value: 2, label: translator(translate.ISA_Short_February, 'ก.พ.') },
        { value: 3, label: translator(translate.ISA_Short_March, 'มี.ค.') },
        { value: 4, label: translator(translate.ISA_Short_April, 'เม.ย.') },
        { value: 5, label: translator(translate.ISA_Short_May, 'พ.ค.') },
        { value: 6, label: translator(translate.ISA_Short_June, 'มิ.ย.') },
        { value: 7, label: translator(translate.ISA_Short_July, 'ก.ค.') },
        { value: 8, label: translator(translate.ISA_Short_August, 'ส.ค.') },
        { value: 9, label: translator(translate.ISA_Short_September, 'ก.ย.') },
        { value: 10, label: translator(translate.ISA_Short_October, 'ต.ค.') },
        { value: 11, label: translator(translate.ISA_Short_November, 'พ.ย.') },
        { value: 12, label: translator(translate.ISA_Short_December, 'ธ.ค.') }
    ];
};

export const getTranslatedMonthData = (translator, translate) => {
    return [
        { value: 1, label: translator(translate.ISA_January, 'มกราคม') },
        { value: 2, label: translator(translate.ISA_February, 'กุมภาพันธ์') },
        { value: 3, label: translator(translate.ISA_March, 'มีนาคม') },
        { value: 4, label: translator(translate.ISA_April, 'เมษายน') },
        { value: 5, label: translator(translate.ISA_May, 'พฤษภาคม') },
        { value: 6, label: translator(translate.ISA_June, 'มิถุนายน') },
        { value: 7, label: translator(translate.ISA_July, 'กรกฎาคม') },
        { value: 8, label: translator(translate.ISA_August, 'สิงหาคม') },
        { value: 9, label: translator(translate.ISA_September, 'กันยายน') },
        { value: 10, label: translator(translate.ISA_October, 'ตุลาคม') },
        { value: 11, label: translator(translate.ISA_November, 'พฤศจิกายน') },
        { value: 12, label: translator(translate.ISA_December, 'ธันวาคม') }
    ];
};

export const getTranslatedMonthDataLLG = (translator, translate) => {
    return [
        { value: 1, label: translator(translate.ISA_December, 'ธันวาคม') },
        { value: 2, label: translator(translate.ISA_January, 'มกราคม') },
        { value: 3, label: translator(translate.ISA_February, 'กุมภาพันธ์') },
        { value: 4, label: translator(translate.ISA_March, 'มีนาคม') },
        { value: 5, label: translator(translate.ISA_April, 'เมษายน') },
        { value: 6, label: translator(translate.ISA_May, 'พฤษภาคม') },
        { value: 7, label: translator(translate.ISA_June, 'มิถุนายน') },
        { value: 8, label: translator(translate.ISA_July, 'กรกฎาคม') },
        { value: 9, label: translator(translate.ISA_August, 'สิงหาคม') },
        { value: 10, label: translator(translate.ISA_September, 'กันยายน') },
        { value: 11, label: translator(translate.ISA_October, 'ตุลาคม') },
        { value: 12, label: translator(translate.ISA_November, 'พฤศจิกายน') }
    ];
};

export const translateShortMonth = (shortMonthTxt) => {
    const monthData = [
      { value: "jan", label: shortMonthTxt.jan },
      { value: "feb", label: shortMonthTxt.feb },
      { value: "mar", label: shortMonthTxt.mar },
      { value: "apr", label: shortMonthTxt.apr },
      { value: "may", label: shortMonthTxt.may },
      { value: "jun", label: shortMonthTxt.jun },
      { value: "jul", label: shortMonthTxt.jul },
      { value: "aug", label: shortMonthTxt.aug },
      { value: "sep", label: shortMonthTxt.sep },
      { value: "oct", label: shortMonthTxt.oct },
      { value: "nov", label: shortMonthTxt.nov },
      { value: "dec", label: shortMonthTxt.dec }
    ];
  
    return monthData;
}

export const translateShortMonthLLG = (shortMonthTxt) => {
    const monthData = [
      { value: "jan", label: shortMonthTxt.dec },
      { value: "feb", label: shortMonthTxt.jan },
      { value: "mar", label: shortMonthTxt.feb },
      { value: "apr", label: shortMonthTxt.mar },
      { value: "may", label: shortMonthTxt.apr },
      { value: "jun", label: shortMonthTxt.may },
      { value: "jul", label: shortMonthTxt.jun },
      { value: "aug", label: shortMonthTxt.jul },
      { value: "sep", label: shortMonthTxt.aug },
      { value: "oct", label: shortMonthTxt.sep },
      { value: "nov", label: shortMonthTxt.oct },
      { value: "dec", label: shortMonthTxt.nov }
    ];
  
    return monthData;
}

export const translateShortMonthSSP = (shortMonthTxt) => {
    const monthData = [
      { value: "jan", label: shortMonthTxt.oct },
      { value: "feb", label: shortMonthTxt.nov },
      { value: "mar", label: shortMonthTxt.dec },
      { value: "apr", label: shortMonthTxt.jan },
      { value: "may", label: shortMonthTxt.feb },
      { value: "jun", label: shortMonthTxt.mar },
      { value: "jul", label: shortMonthTxt.apr },
      { value: "aug", label: shortMonthTxt.may },
      { value: "sep", label: shortMonthTxt.jun },
      { value: "oct", label: shortMonthTxt.jul },
      { value: "nov", label: shortMonthTxt.aug },
      { value: "dec", label: shortMonthTxt.sep }
    ];
  
    return monthData;
}